const placeholder = {
  id: 'countrySelector.placeholder',
};

const textIds = {
  placeholder,
};

export default textIds;
